import { render, staticRenderFns } from "./getPostage.vue?vue&type=template&id=10426db3"
import script from "./getPostage.vue?vue&type=script&lang=js"
export * from "./getPostage.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./getPostage.vue?vue&type=style&index=0&id=10426db3&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "4bbd7b93"
  
)

export default component.exports